import { getTournament } from 'api/events';
import React, { useCallback } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import JornadasBaloncesto from './jornadasBaloncesto/JornadasBaloncesto';
import JornadasFutbol from './jornadasFutbol/JornadasFutbol';
import JornadasVolleyBall from './jornadasVolleyball/JornadasVolleyball';

const Jornadas = () => {
  let { eventId } = useParams();

  const eventResolver = useCallback(async (key, _eventId) => {
    const { body, status } = await getTournament(_eventId);

    return { event: body?.data?.tournament, status } || null;
  }, []);

  const { data: eventData, refetch: reloadEvent, status } = useQuery(
    ['event', eventId],
    eventResolver,
  );

  switch (eventData?.event?.sport_name) {
    case 'Volleyball':
      return <JornadasVolleyBall />;
    case 'Basketball':
      return <JornadasBaloncesto />;
    default:
      return <JornadasFutbol />;
  }
};

export default Jornadas;
